const normalizeChoice = (text) => text
	.normalize('NFD')
	.replace(/[\u0300-\u036f]/g, '')
	.toLowerCase()
	.replace(/[^a-z0-9]/g, '');

const isSelectAll = (input) => Array.from(input.labels || []).some(
	(label) => normalizeChoice(label.textContent) === 'selectall'
) || normalizeChoice(input.value) === 'selectall';

export default function initGravityFormsSelectAll() {
	const updating = new WeakSet();

	// Delegation also covers forms rendered later through AJAX or inside modals.
	document.addEventListener('change', (event) => {
		const input = event.target;
		if (!input.matches('.gform_wrapper .gfield_checkbox input[type="checkbox"]')) {
			return;
		}

		const group = input.closest('.gfield_checkbox');
		if (updating.has(group)) {
			return;
		}

		const choices = Array.from(group.querySelectorAll('input[type="checkbox"]'))
			.filter((choice) => !choice.disabled);
		const toggle = choices.find(isSelectAll);
		if (!toggle) {
			return;
		}

		const options = choices.filter((choice) => choice !== toggle);
		updating.add(group);
		try {
			if (input === toggle) {
				const checked = toggle.checked;
				options.forEach((choice) => {
					if (choice.checked !== checked) {
						choice.checked = checked;
						choice.dispatchEvent(new Event('change', { bubbles: true }));
					}
				});
			} else {
				const checked = options.length > 0 && options.every((choice) => choice.checked);
				if (toggle.checked !== checked) {
					toggle.checked = checked;
					toggle.dispatchEvent(new Event('change', { bubbles: true }));
				}
			}
		} finally {
			updating.delete(group);
		}
	});
}
